import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setProgress } from '../../../../reducers/wizard';
import Wizard from './../../../../components/wizard';
import { getSteps } from './steps';

class WitnessOnboarding extends React.Component {
    componentDidMount() {
        const { i9, setProgress } = this.props;
        const progress = i9.progress ? i9.progress : { step: 0, branch: 'default' };
        setProgress({ entity: 'i9', id: i9.id }, progress);
    }

    render() {
        const { i9 } = this.props;
        if (!i9 || !i9.progress) return null;

        return <Wizard configuration={{ entity: 'i9', id: i9.id }} getSteps={(controls, progress) => getSteps(controls, progress, this.props)} />;
    }
}

const mapStateToProps = (state, props) => ({
    role: state.identity.role,
    i9: state.identity.details
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setProgress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(WitnessOnboarding);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/index.jsx